import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const SelectMapIcon = ({ className }) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" className={className}>
    <path d="M7.9582 14.7118L3.5127 10.2663L4.40372 9.37533L7.9582 12.9298L15.596 5.29199L16.487 6.18299L7.9582 14.7118Z" fill="#333945"/>
  </SvgIcon>
);

export default SelectMapIcon;
